import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { NPolls } from '../interfaces/services/polls.interfaces'
import { PostPollCard } from '../generated/api/post-row'
import { CreatePollBody, PatchPollBody } from '../generated/api/poll-commands'
import { createUrl } from './helpers'
import axiosAuth from './config'

type PollCardResponse = AxiosResponse<{ data: PostPollCard }>

export const getPollCard = (
  id: string,
  signal?: AbortSignal
): Promise<PollCardResponse> => {
  return axiosAuth.get<{ data: PostPollCard }>(createUrl(`/polls/${id}`), {
    signal,
  })
}

export const createPoll = (body: CreatePollBody): Promise<PollCardResponse> => {
  return axiosAuth.post<{ data: PostPollCard }>(createUrl('/polls'), body)
}

export const patchPoll = (variables: {
  id: string
  body: PatchPollBody
}): Promise<PollCardResponse> => {
  return axiosAuth.patch<{ data: PostPollCard }>(
    createUrl(`/polls/${variables.id}`),
    variables.body
  )
}

export const vote = (variables: {
  id: string
  optionId: string
}): Promise<PollCardResponse> => {
  return axiosAuth.post<{ data: PostPollCard }>(
    createUrl(`/polls/${variables.id}/vote`),
    { optionId: variables.optionId }
  )
}

export const unvote = (id: string): Promise<PollCardResponse> => {
  return axiosAuth.post<{ data: PostPollCard }>(
    createUrl(`/polls/${id}/unvote`)
  )
}

export const getVotes = (
  id: string
): Promise<AxiosResponse<NPolls.NGetVotes.IResponse>> => {
  return axiosAuth.get<NPolls.NGetVotes.IResponse>(
    createUrl(`/polls/poll/${id}/votes`)
  )
}

export const pollQueries = {
  card: (pollId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'poll', entity: 'card', pollId }] as const,
      enabled: !!pollId,
      queryFn: async ({ queryKey, signal }) =>
        (await getPollCard(queryKey[0].pollId as string, signal)).data.data,
    }),
}
